<template>
  <dv-border-box-10 id="scroll-board2">
    <div>
      <div class="ranking-board-title">
        设备数据曲线
        <a
          v-show="page_config.showDataDownload"
          :href="'/sites/wz_data_download/?ids=' + authUserInfo.devGroupIds"
          target="_blank"
          rel="noopener noreferrer"
          style="    position: absolute;
    right: 10px;
    font-size: 16px;
    line-height: 50px;"
          >数据打印</a
        >
      </div>

      <div style="white-space: nowrap;">
        <el-cascader
          style="width: 8.81vw"
          size="small"
          v-model="regionSelect"
          :options="stations"
          @change="regionSelectChange"
          :props="{ label: 'name', value: 'station_id' }"
        >
        </el-cascader>
        <el-date-picker
          style="width: 24.23vw"
          size="small"
          @change="timeRangeChanged"
          v-model="timeRangeCtrl"
          format="yyyy-MM-dd HH:mm"
          type="datetimerange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
        >
        </el-date-picker>
      </div>
    </div>
    <div id="chart1" style="height: 25vh;margin-top: 1vh"></div>
  </dv-border-box-10>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import HighCharts from "highcharts";
import { getStationDataTimeSlot, getStationSampleDevice } from "@/api/api";
import { option } from "@/options/option";
import { check_time_range } from "@/utils/utils";
// const sensortypes = [
//   { value: "pm10", label: "PM₁₀" },
//   { value: "pm25", label: "PM₂.₅" },
//   { value: "wendu", label: "温度" },
//   { value: "shidu", label: "湿度" },
//   { value: "wind_speed", label: "风速" }
// ];
export default {
  name: "tableBlock",
  data() {
    return {
      option,
      playInterval: null,
      regionSelect: [],
      interval: null,
      gfInterval: null,
      series: [],
      choose_time: "0",
      hasPlotLines: false
    };
  },
  mounted() {
    this.setIntervalData();
    this.initCharts();
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "groupId",
      "stations",
      "timeRange",
      "data_time",
      "mode",
      "playSpeed",
      "time_type",
      "sensortype",
      "sensortypes",
      "page_config",
      "locateAlarm",
      "mapMode",
      "stationData"
    ]),
    regionOptions() {
      return [
        {
          value: 2,
          label: "站点"
        }
      ];
    },
    timeRangeCtrl: {
      get() {
        return this.timeRange;
      },
      set(v) {
        let time_range_mod = check_time_range(v[0], v[1], this.time_type);
        let timeRangeCtrl = [time_range_mod.start, time_range_mod.end];
        this.$store.commit("setTimeRange", timeRangeCtrl);
      }
    },
    isPM() {
      return this.sensortype === "pm25" || this.sensortype === "pm10";
    }
  },
  watch: {
    choose_time() {
      let dataTime;
      if (this.choose_time) {
        dataTime = this.$moment(this.choose_time * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      } else {
        switch (this.time_type) {
          case "real" || "min":
            dataTime = this.$moment()
              .subtract(1, "minutes")
              .format("YYYY-MM-DD HH:mm:00");
            break;
          case "hour":
            dataTime = this.$moment()
              .subtract(1, "hours")
              .format("YYYY-MM-DD HH:00:00");
            break;
          case "day":
            dataTime = this.$moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD");
            break;
          case "week":
            dataTime = this.$moment()
              .subtract(7, "days")
              .format("YYYY-MM-DD");
            break;
          case "month":
            dataTime = this.$moment()
              .subtract(1, "months")
              .endOf()
              .format("YYYY-MM-DD");
            break;
        }
      }
      this.$store.commit("setDataTime", dataTime);
    },
    timeRange() {
      this.drawChart();
    },
    time_type() {
      this.setIntervalData();
      this.drawChart();
    },
    // stations() {
    //   this.initCharts();
    // },
    sensortype() {
      this.updateChart();
      this.updatePlotLines();
    },
    locateAlarm() {
      let start, end;
      if (this.mapMode == "alarm") {
        this.regionSelect = [this.locateAlarm.station_id];
        start = this.$moment(this.locateAlarm.update_time).subtract(
          12,
          "hours"
        );
        end = this.$moment(this.locateAlarm.update_time).add(12, "hours");
      } else {
        start = this.$moment().subtract(24, "hours");
        end = this.$moment();
      }
      this.$store.commit("setTimeRange", [start, end]);
      this.drawChart();
      this.updatePlotLines();
    }
  },
  methods: {
    initCharts() {
      console.log("initCharts");
      let self = this;
      if (this.stations.length === 0) {
        this.$store.commit("setStationData", []);
        return;
      }
      const curStationInfo = this.stations.find(x => x.DevSN.length <= 9);
      this.regionSelect = [
        curStationInfo?.station_id || this.stations[0].station_id
      ];
      this.chart1 = HighCharts.chart("chart1", this.option);
      this.drawChart();
    },
    timeRangeChanged(v) {
      console.log(v);
    },
    setIntervalData() {
      this.interval && clearInterval(this.interval);
      if (this.time_type !== "min") {
        return;
      }
      this.interval = setInterval(() => {
        this.$store.commit("setTimeRange", [
          this.$moment().subtract(2, "hours"),
          this.$moment()
        ]);
        this.$store.dispatch("getStationSampleDeviceStatus");
        this.$store.dispatch("getStationData");
      }, 30000);

      this.gfInterval && clearInterval(this.gfInterval);

      this.gfInterval = setInterval(() => {
        // this.$store.dispatch("getGfStationsInfo");
        this.$store.dispatch("getGfStationData");
      }, 1800000);
    },
    drawChart(updateLinet = true) {
      this.chart1.showLoading();
      let format = "YYYY-MM-DD HH:mm:00";
      let params1 = {
        alltype: "1",
        station_id: this.regionSelect[0],
        start_time: this.$moment(this.timeRange[0]).format(format),
        end_time: this.$moment(this.timeRange[1]).format(format),
        time_type: this.time_type === "real" ? "min" : this.time_type
      };
      getStationDataTimeSlot(params1)
        .then(d => {
          let regionData = d.data;
          let chartData = [];
          let chartData2 = [];
          this.series = [];
          let choose_time = 0;
          if (this.mapMode === "alarm") {
            var alarm_time = "",
              time_d = Infinity,
              alarm_unix = this.$moment(this.locateAlarm.update_time).unix();
          }
          for (let sensor of this.sensortypes) {
            let seriesData = [];
            let timeStamps = [];
            const sensortypeIndex = regionData.columns.indexOf(sensor.value);
            regionData.values.forEach(item => {
              if (item[0] > choose_time) {
                choose_time = item[0];
              }
              if (!timeStamps.includes(item[0] * 1000))
                seriesData.push([item[0] * 1000, item[sensortypeIndex]]);

              if (this.mapMode === "alarm") {
                // 找到距离报警时间最近的点
                const time_d_item = Math.abs(item[0] - alarm_unix);
                if (time_d_item < time_d) {
                  time_d = time_d_item;
                  alarm_time = item[0];
                }
              }
            });
            seriesData = seriesData.sort((a, b) => a[0] - b[0]);
            this.series.push({
              id: sensor.value,
              name: sensor.label,
              data: seriesData,
              timetype: this.time_type
            });
          }

          if (this.mapMode === "alarm" && alarm_time) {
            alarm_time = this.$moment(alarm_time * 1000).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            // this.$store.commit("setDataTime", alarm_time)
            this.$store.dispatch("getStationData", alarm_time);
          }

          if (this.mapMode === "current") {
            this.choose_time = choose_time;
          }
          this.updateChart();
          this.chart1.hideLoading();
        })
        .catch(e => {
          this.series = [];
          this.updateChart();
          this.chart1.hideLoading();
        });
    },
    regionSelectChange(e) {
      this.drawChart();
      // 如果选择站点是报警站点 绘制竖线, 不是则删除竖线
      const station_id = this?.locateAlarm?.station_id;
      if (station_id == e[0]) {
        this.updatePlotLines();
      } else {
        this.chart1.xAxis[0].removePlotLine("plotline-1");
        this.chart1.xAxis[0].removePlotLine("plotline-2");
      }
    },
    updateChart() {
      this.clearChart();
      if (this.series.length === 0) {
        return;
      }
      if (this.isPM) {
        for (let s of this.series) {
          if (s.id === "pm25" || s.id === "pm10") {
            this.chart1.addSeries(s);
          }
        }
      } else {
        const s = this.series.filter(item => item.id === this.sensortype)[0];
        this.chart1.addSeries(s);
      }
    },
    updatePlotLines() {
      this.chart1.xAxis[0].removePlotLine("plotline-1");
      this.chart1.xAxis[0].removePlotLine("plotline-2");
      if (this.mapMode === "alarm") {
        this.chart1.xAxis[0].addPlotLine({
          color: "#FF0000",
          width: 2,
          value: this.$moment(this.locateAlarm.update_time).valueOf(),
          id: "plotline-1"
        });

        this.chart1.xAxis[0].addPlotLine({
          color: "#FF0000",
          width: 2,
          value: this.$moment(this.locateAlarm.start_time).valueOf(),
          id: "plotline-2"
        });
      }
    },
    clearChart() {
      for (let item of this.sensortypes) {
        const s = this.chart1.get(item.value);
        if (s) {
          s.remove();
        }
      }
    }
  }
};
</script>

<style lang="less">
.tools {
  height: 8.547vh;
}
.timeControlBox {
  float: right;
}
.timeControlBox .btn {
  display: block;
  height: 4.34vh;
  // line-height: 5.34vh;
  width: 2.6vw;
  // margin-top: 18px;
  // margin-right:15px;
  box-shadow: 0 2px 2px #051d4b;
}
.timeControlBox .play {
  background: url(../assets/img/play.png) no-repeat left top;
  background-size: 71%;
}
.timeControlBox .pause {
  background: url(../assets/img/pause.png) no-repeat left top;
  background-size: 71%;
}

// .timeControlBox .pause{
// 	background-position:0 -65px;
// }
// .timeControlBox .play:hover{
// 	background-position:-65px 0;
// }
// .timeControlBox .pause:hover{
// 	background-position:-65px -65px;
// }

#scroll-board2 {
  // width: 50%;
  box-sizing: border-box;
  // margin-left: 20px;
  height: 39.5%;
  overflow: hidden;
}
</style>
